import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/invest/plans.js");
;
import(/* webpackMode: "eager", webpackExports: ["InvestmentImages"] */ "/vercel/path0/app/invest/ThreeDCardDemo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionDiv"] */ "/vercel/path0/components/ui/animateOnEnter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundBeamsWithCollision"] */ "/vercel/path0/components/ui/background-beams-with-collision.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FocusCards"] */ "/vercel/path0/components/ui/focus-cards.tsx");
